export type User = {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  avatar_url: string | null;
  created_at: string;
  featurebase_user_hash?: string | null;
  has_password?: boolean;
};

export type LoginResponse = {
  email: string;
  user_id: number;
  jwt_token: string;
  default_scenario_id: string | null;
};

// Acknowledges that a confirmation link went out; nothing on the account moved yet.
export type EmailChangeRequested = {
  pending_email: string;
};

export type UserEmailChangeInput = {
  email: string;
  current_password: string;
};

export const ACCOUNT_DELETION_REASONS = [
  'just_testing',
  'not_good_enough',
  'hard_to_set_up',
  'missing_feature',
  'too_expensive',
  'switching_tool',
  'other',
] as const;

export type AccountDeletionReason = (typeof ACCOUNT_DELETION_REASONS)[number];

export type AccountDeletionInput = {
  confirmation_email: string;
  current_password?: string;
  reason?: AccountDeletionReason;
  reason_details?: string;
};
